import React from 'react';
import { getEstimatorQueriesCacheByIds } from '../../api/estimator/estimatorsQueriesCache';

export const renderTextualQuotationServerSide = async props => {
  const { text, preventiviIds = '' } = props;
  const preventiviIdsArr = preventiviIds.split(',');
  const responseQueriesCache = await getEstimatorQueriesCacheByIds(preventiviIdsArr);
  const { data: queriesCacheData } = responseQueriesCache;

  const regex = /<([a-zA-Z]+)\.(\d+)>/g;

  const quotationValues = queriesCacheData.map(q => {
    const quotations = q?.queryResult?.preventivi ? Object.values(q.queryResult.preventivi) : null;
    const firstQuotation = quotations && quotations[0] && quotations[0][0] ? quotations[0][0] : {};
    return { ...q.queryBody, ...firstQuotation };
  });

  // Usiamo il metodo replace con una funzione di callback
  const newText = text.replace(regex, (match, key, keyIndex) => {
    // Controlliamo se la chiave esiste negli oggetti di valori
    if (quotationValues[keyIndex] && quotationValues[keyIndex][key]) {
      return quotationValues[keyIndex][key]; // Sostituiamo con il valore corrispondente
    } else {
      return match; // Se non troviamo un valore, lasciamo il segnaposto non sostituito
    }
  });

  return newText;
};

const TextualQuotation = () => {
  return <div></div>;
};

export default TextualQuotation;
